import IProductDatabase from './IProductDatabase';
import ITopicBase from './ITopicBase';
import ITopic from './ITopic';
import IProductBase from './IProductBase';
import IProduct from './IProduct';
import IProductClass from './IProductClass';
import VideoFile from './VideoFile';
import _ from 'lodash';

const LOREM_DESC = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' +
  ' Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';

export default class ProductDatabase implements IProductDatabase {

  private whitelabelPath: string;

  private topics: ITopicBase[];
  private productList: IProductBase[];
  private productClassList: IProductClass[];
  private videoList: VideoFile[] = [
    { mp4: '190408_10_MonarchLifecycle3_08.mp4', vtt: null, title: 'Monarch Lifecycle'},
    { mp4: 'bannerg004.mp4', vtt: null, title: 'Banner G'},
    { mp4: 'BirdNoSound.mp4', vtt: null, title: 'Bird No Sound'},
    { mp4: 'Clownfishes_in_Anemone.mp4', vtt: 'Clownfishes_in_Anemone.vtt', title: 'Clownfish in Anemone'},
    { mp4: 'DSC_1738MP4_upload_version.mp4', vtt: null, title: 'Title'},
    { mp4: 'Grey_Squirrel_Eating.mp4', vtt: 'Grey_Squirrel_Eating.vtt', title: 'Squirrel Eating'},
    { mp4: 'greypass003.mp4', vtt: null, title: 'Gray Pigeon'},
    { mp4: 'Red_fody.mp4', vtt: null, title: 'Red Fody'},
    { mp4: 'sailing_boat.mp4', vtt: null, title: 'Sailing Boat'}
  ];

  constructor(whitelabelPath: string) {
    this.whitelabelPath = whitelabelPath;
    this.productList = [];
    for (let i = 1; i <= 35; i++) {
      const padded: string = (i < 10) ? '0' + i : '' + i;
      this.productList.push({
        id: i,
        name: `Some Name ${i}`,
        image: 'product-' + padded + '.jpg',
        description: LOREM_DESC,
        priceInCents: 7900 + (i % 6) * 500,
      });
    }
    this.productClassList = [];
    for (let i = 101; i <= 107; i++) {
      const x = (i % 7) + 1;
      const padded: string = (x < 10) ? '0' + x : '' + x;
      this.productClassList.push({
        id: i,
        name: `ProductClass ${i}`,
        products: [x],
        image: 'product-' + padded + '.jpg',
      });
    }
    this.topics = [
      {
        id: 'aspect-a',
        name: 'Aspect A',
        title: 'Aspect A Title',
        description: LOREM_DESC,
        videos: [ this.videoList[2], this.videoList[4] ],
        products: _.filter(this.productList, (p) => 0 === (p.id % 3)),
      },
      {
        id: 'quality-b',
        name: 'Quality B',
        title: 'Quality B Title',
        description: LOREM_DESC,
        videos: [ this.videoList[3], this.videoList[6] ],
        products: _.filter(this.productList, (p) => 0 === (p.id % 5)),
      },
      {
        id: 'factor-c',
        name: 'Factor C',
        title: 'Factor C Title',
        description: LOREM_DESC,
        videos: [ this.videoList[0], this.videoList[5] ],
        products: _.filter(this.productList, (p) => 0 === (p.id % 6)),
      }
    ];
  }

  public getWhitelabelPath(): string {
    return this.whitelabelPath;
  }

  public getAllVideoFiles(): VideoFile[] {
    return this.videoList;
  }

  public getFrontPageVideoFiles(): VideoFile[] {
    return [ this.videoList[5], this.videoList[3], this.videoList[0] ];
  }

  public getTopicById(topicId: string): ITopic {
    const topic = _.find(this.topics, (t) => topicId === t.id);
    return topic ? this.constructTopic(topic) : this.constructTopic(this.topics[0]);
  }

  public getAllProducts(): IProduct[] {
    return _.map<IProductBase, IProduct>(this.productList, (p) => this.toIProduct(p));
  }

  public getAllProductClasses(): IProductClass[] {
    return this.productClassList;
  }

  public getProductById(productId: number): IProduct | undefined {
    const product = _.find(this.productList, (p) => 0 === (p.id - productId));
    return product ? this.toIProduct(product) : undefined;
  }

  public getAllTopics(): ITopic[] {
    return _.map<ITopicBase, ITopic>(this.topics, (topic) => this.constructTopic(topic));
  }

  private constructTopic(topic: ITopicBase): ITopic {
    return {
      id: topic.id,
      name: topic.name,
      title: topic.title,
      description: topic.description,
      videos: topic.videos,
      products: _.map<IProductBase, IProduct>(topic.products, (p) => this.toIProduct(p)),
    };
  }

  private toIProduct(product: IProductBase): IProduct {
    const topicIds = this.getTopicIdsHavingProduct(product.name);
    return {
      ...product,
      rating: 8 + ((product.id * 11) % 3),
      topicIds,
    };
  }

  private getTopicIdsHavingProduct(productName: string): string[] {
    return _.map(
      _.filter(this.topics, (topic) => {
        return -1 < _.findIndex(topic.products, (p) => p.name === productName);
      }),
      (topic) => topic.id
    );
  }


}

